import React from 'react'

// Use this component as a page loading spinner
// This loading spinner is three concentric 25% circular arcs that spin at different speeds
export function LoadingTripleSpinner() {
  return <div className="loading-spinner before:opacity-[.6] after:opacity-[.3]" />
}
